/**
 * 分析ページのクライアント側「1 画面あたりのスケジュール表示上限」（プランごと）。
 * サーバー側の取得件数ハード上限とは別レイヤーの制御。
 */
export const ANALYSIS_DISPLAY_MAX_SCHEDULES_FREE = 100;
export const ANALYSIS_DISPLAY_MAX_SCHEDULES_PAID = 5000;

/** {@link logCustomAnalyticsEvent} の metadata.error_code に送る値 */
export const SCHEDULE_DISPLAY_LIMIT_EXCEEDED_CODE = 'CLIENT_SCHEDULE_DISPLAY_LIMIT_EXCEEDED';

export function getAnalysisDisplayScheduleLimit(isPaid: boolean): number {
    return isPaid ? ANALYSIS_DISPLAY_MAX_SCHEDULES_PAID : ANALYSIS_DISPLAY_MAX_SCHEDULES_FREE;
}
